module.exports = __webpack_public_path__ + "img/bubuia_map.0252d39d.jpg";